import { Injectable } from '@angular/core';
import { DomainAction } from '@engagement/core/store/domain/domain.dispatcher';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { fromEngagement, RootState } from '@root-store/index';
import { filter, map, merge, withLatestFrom } from 'rxjs';

import { TileDispatcher, TileId } from '@contact/upgrade';

@Injectable()
export class EngagementSystemEffect {
  /**
   * If error occured before Agent be ready
   * we reset application
   */
  readonly initError$ = createEffect(() =>
    merge(
      this.actions$.pipe(
        ofType(DomainAction.LoadFail),
        map(() => 'engagement:error.domain_load_fail')
      )
    ).pipe(
      withLatestFrom(this.store$.pipe(select(fromEngagement.isEngagementReady))),
      filter(([_, ready]) => !ready),
      map(([message]) =>
        this.tileDispatcher.reset({
          message,
          tileId: TileId.ENGAGEMENT,
        })
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store<RootState>,
    private readonly tileDispatcher: TileDispatcher
  ) {}
}
